import { Pipe, PipeTransform } from '@angular/core';
import { Resource } from '@klickdata/core/resource';

@Pipe({
    name: 'resourcePublishmentStatus',
})
export class ResourcePublishmentStatusPipe implements PipeTransform {
    grey = '#b6b6b6';
    orange = '#ff9961';
    red = '#e44a66';
    white = '#fff';
    darkblue = '#3e5365';
    green = '#bfd8d0';
    iceblue = '#93cbd1';
    transform(res: Resource): { status: string; color: string; icon: string; tooltip?: string } {
        if (!res.last_publish) {
            return {
                status: $localize`Draft`,
                color: this.getDraftColor(res),
                icon: 'public_off',
                tooltip: this.getDraftTooltip(res),
            };
        } else if (res.public) {
            return { status: $localize`Public`, color: this.darkblue, icon: 'public' };
        } else if (!res.public) {
            return { status: $localize`:@@academy:Academy`, color: this.iceblue, icon: 'published_with_changes' };
        }
    }
    getDraftColor(res: Resource): string {
        switch (res.accessRole) {
            case 'owned':
                return this.grey;
            case 'owned_with_editors':
                return this.orange;
            case 'editor':
                return this.green;
            // case 'acquired':
            //     return this.red;
            default:
                return this.grey;
        }
    }
    getDraftTooltip(res: Resource): string {
        if (res.accessRole === 'owned_with_editors' && !!res.managers?.length) {
            return $localize`${res.managers.map((manager) => manager.name).join(' and ')} are authors`;
        }
    }
}
